import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import deleteaction from "../../context/action/company/deleteaction";
import updateaction from "../../context/action/company/updateaction";

const Editcompanymodal = (props) => {
  const { initState, recaller, setrecaller, clear, initDispatch } =
    useContext(GlobalContext);

  const [error, seterror] = useState(false);
  const [error1, seterror1] = useState(false);
  const [error2, seterror2] = useState(false);
  return (
    <>
      {props.show ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none p-4">
            <div className="relative my-2 sm:my-4 md:my-6 mx-auto w-full sm:w-2/3 md:w-1/2 lg:w-2/5">
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/* Header */}
                <div className="flex items-center justify-between p-3 sm:p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-xl sm:text-2xl md:text-3xl uppercase font-semibold flex-1">
                    گۆڕانکاری
                  </h3>
                  <button
                    className="p-1 ml-auto text-black opacity-80 text-2xl sm:text-3xl leading-none font-semibold"
                    onClick={() => props.setshow(false)}
                  >
                    <span className="block">X</span>
                  </button>
                </div>

                {/* Body */}
                <div className="relative p-4 sm:p-6 flex-auto">
                  <div className="flex flex-col gap-4">
                    {/* Company Name Input */}
                    <div className="w-full">
                      <label
                        className={`block uppercase tracking-wide text-xs font-bold mb-2
                          ${error ? "text-red-500" : "text-gray-700"}`}
                      >
                        ناوی کۆمپانیا
                      </label>
                      <input
                        className={`appearance-none block w-full bg-gray-50 
                          text-gray-700 border rounded py-2 sm:py-3 px-3 sm:px-4 
                          leading-tight transition duration-150 ease-in-out
                          focus:outline-none focus:bg-white focus:border-gray-500
                          ${error ? "border-red-500" : "border-gray-200"}`}
                        type="text"
                        placeholder="ناوی کۆمپانیا"
                        value={props.company_name}
                        onChange={(val) => props.setcompany_name(val.target.value)}
                        onFocus={() => seterror(false)}
                      />
                    </div>

                    {/* Address Input */}
                    <div className="w-full">
                      <label
                        className={`block uppercase tracking-wide text-xs font-bold mb-2
                          ${error1 ? "text-red-500" : "text-gray-700"}`}
                      >
                        ناونیشان
                      </label>
                      <input
                        className={`appearance-none block w-full bg-gray-50 
                          text-gray-700 border rounded py-2 sm:py-3 px-3 sm:px-4 
                          leading-tight transition duration-150 ease-in-out
                          focus:outline-none focus:bg-white focus:border-gray-500
                          ${error1 ? "border-red-500" : "border-gray-200"}`}
                        type="text"
                        placeholder="ناونیشان"
                        value={props.company_address}
                        onChange={(val) => props.setcompany_address(val.target.value)}
                        onFocus={() => seterror1(false)}
                      />
                    </div>

                    {/* Phone Input */}
                    <div className="w-full">
                      <label
                        className={`block uppercase tracking-wide text-xs font-bold mb-2
                          ${error2 ? "text-red-500" : "text-gray-700"}`}
                      >
                        ژمارەی تەلەفۆن
                      </label>
                      <input
                        className={`appearance-none block w-full bg-gray-50 
                          text-gray-700 border rounded py-2 sm:py-3 px-3 sm:px-4 
                          leading-tight transition duration-150 ease-in-out
                          focus:outline-none focus:bg-white focus:border-gray-500
                          ${error2 ? "border-red-500" : "border-gray-200"}`}
                        type="text"
                        placeholder="ژمارەی تەلەفۆن"
                        value={props.company_phone}
                        onChange={(val) => props.setcompany_phone(val.target.value)}
                        onFocus={() => seterror2(false)}
                      />
                    </div>
                  </div>
                </div>

                {/* Footer */}
                <div className="flex flex-wrap sm:flex-nowrap items-center justify-end gap-2 p-3 sm:p-6 border-t border-solid border-slate-200 rounded-b">
                  <button
                    className="w-full sm:w-auto bg-red-500 text-white active:bg-red-600 
                      font-bold uppercase text-sm px-4 sm:px-6 py-2 sm:py-3 rounded 
                      shadow hover:shadow-lg transition-all duration-150"
                    onClick={() => {
                      if (window.confirm("ئاگاداری ڕەشکردنەوە . دڵنیای ؟")) {
                        deleteaction(props.company_id)(recaller)(setrecaller)(initDispatch)(clear);
                      }
                    }}
                  >
                    ڕەشکردنەوە
                  </button>
                  <button
                    className="w-full sm:w-auto bg-emerald-500 text-white active:bg-emerald-600 
                      font-bold uppercase text-sm px-4 sm:px-6 py-2 sm:py-3 rounded 
                      shadow hover:shadow-lg transition-all duration-150"
                    onClick={() => {
                      if (props.company_name == "" || !props.company_name) {
                        seterror(true);
                        return false;
                      }
                      if (
                        props.company_address == "" ||
                        !props.company_address
                      ) {
                        seterror1(true);
                        return false;
                      }
                      if (props.company_phone == "" || !props.company_phone) {
                        seterror2(true);
                        return false;
                      }
                      if (
                        window.confirm(
                          "ئاگاداری ئەنجامدانی گۆڕانکاری . دڵنیای ؟"
                        ) == true
                      ) {
                        updateaction(
                          props.company_id,
                          props.company_name,
                          props.company_address,
                          props.company_phone
                        )(recaller)(setrecaller)(initDispatch)(clear);
                      }
                    }}
                  >
                    گۆڕانکاری
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};

export default Editcompanymodal;
